import { Button } from '@design-system/button';
import React, { FC } from 'react';

import { isFilterActive } from '../utils';
import { FilterGroupOptionsProps } from './models';

const FilterGroupOptions: FC<FilterGroupOptionsProps> = ({
  options,
  filter,
  handleFilterChange,
  activeGroup,
}) => (
  <div className="filter-group__options">
    {options.map(({ optionLabel, categoryRef }) => (
      <Button
        variant={
          isFilterActive(filter, categoryRef.uid) ? 'primary' : 'secondary'
        }
        size="large"
        onClick={() =>
          handleFilterChange(activeGroup, categoryRef, optionLabel)
        }
        key={categoryRef.uid}
      >
        {optionLabel}
      </Button>
    ))}
  </div>
);

export default FilterGroupOptions;
